module.exports = __webpack_public_path__ + "static/media/dito-van-reigersberg.a4593cc2.md";